/* eslint-disable @typescript-eslint/tslint/config */
/* eslint max-classes-per-file: 0 */

import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import { SEO } from "../components/seo";
import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import { RouteComponentProps } from "@reach/router";
import { Helmet } from "react-helmet";

// TODO add mobile support https://www.npmjs.com/package/react-nipple

// Initial code from https://codepen.io/adelciotto/pen/BHuGL

// const tvOn = keyframes`
// 0% {
//   transform: scale(1, 0.8) translate3d(0, 0, 0);
//   -webkit-filter: brightness(30);
//   filter: brightness(30);
//   opacity: 1;
// }
// 3.5% {
//   transform: scale(1, 0.8) translate3d(0, 100%, 0);
// }
// 3.6% {
//   transform: scale(1, 0.8) translate3d(0, -100%, 0);
//   opacity: 1;
// }
// 9% {
//   transform: scale(1.3, 0.6) translate3d(0, 100%, 0);
//   -webkit-filter: brightness(30);
//   filter: brightness(30);
//   opacity: 0;
// }
// 11% {
//   transform: scale(1, 1) translate3d(0, 0, 0);
//   -webkit-filter: contrast(0) brightness(0);
//   filter: contrast(0) brightness(0);
//   opacity: 0;
// }
// 100% {
//   transform: scale(1, 1) translate3d(0, 0, 0);
//   -webkit-filter: contrast(1) brightness(1.2) saturate(1.3);
//   filter: contrast(1) brightness(1.2) saturate(1.3);
//   opacity: 1;
// }
// `;

// const noise = keyframes`
//   0%{background-position:61% 0%}
//   50%{background-position:40% 100%}
//   100%{background-position:61% 0%}
// `;

const zoom = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5);
    animation-timing-function: ease-in;
  } 
  85% {
    opacity: 1;
    transform: scale(2.8);
    animation-timing-function: linear;
  }
  100% {
    opacity: 0;
    transform: scale(3.5);
  }
`;
const Wrapper = styled(motion.div)``;

const Background = styled(motion.div).attrs(() => ({
  transition: {
    loop: Infinity,
    duration: 30,
    times: [0, 15, 30],
  },
  animation: { backgroundPosition: ["61% 0%", "40% 100%", "61% 0%"] },
}))`
  font-family: "Press Start 2P", sans-serif;
  position: absolute;
  overflow: hidden;
  display: block;
  text-align: center;
  color: white;
  margin: auto;
  user-select: none;
  background: black;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  background: linear-gradient(0deg, #111111, #3f3f3f);
  background-size: 400% 400%;
  animation-fill-mode: forwards;
`;

// animation: ${tvOn} 4s linear;

const Star = styled(motion.div).attrs(() => ({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 5 },
}))`
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: radial-gradient(
      2px 2px at 20px 30px,
      #eee,
      rgba(0, 0, 0, 0)
    ),
    radial-gradient(2px 2px at 40px 70px, #fff, rgba(0, 0, 0, 0)),
    radial-gradient(2px 2px at 50px 160px, #ddd, rgba(0, 0, 0, 0)),
    radial-gradient(2px 2px at 90px 40px, #fff, rgba(0, 0, 0, 0)),
    radial-gradient(2px 2px at 130px 80px, #fff, rgba(0, 0, 0, 0)),
    radial-gradient(2px 2px at 160px 120px, #ddd, rgba(0, 0, 0, 0));
  background-repeat: repeat;
  background-size: 200px 200px;
  animation: ${zoom} 5s infinite;
`;

const Star1 = styled(Star)`
  background-position: 50% 50%;
  animation-delay: 0s;
`;
const Star2 = styled(Star)`
  background-position: 20% 60%;
  animation-delay: 1s;
`;
const Star3 = styled(Star)`
  background-position: -20% -30%;
  animation-delay: 2s;
`;
const Star4 = styled(Star)`
  background-position: 40% -80%;
  animation-delay: 3s;
`;
const Star5 = styled(Star)`
  background-position: -20% 30%;
  animation-delay: 4s;
`;

const Stars: React.FC = ({ children }) => (
  <>
    <Star1 />
    <Star2 />
    <Star3 />
    <Star4 />
    <Star5 />
    {children}
  </>
);

const Heading = styled(motion.h1).attrs(() => ({}))`
  font-size: 40px;
  position: relative;
  padding-bottom: 40px;
`;
const Into = styled.div`
  margin: auto;
  color: white;
  padding-top: 20vh;
  z-index: 5;
`;

const BitButton = styled(motion.div).attrs(() => ({
  initial: { opacity: 0.8, scale: 0 },
  animate: { opacity: 1, scale: 1 },
  whileHover: { scale: 1.3 },
  whileTap: { rotate: 30 },
}))`
  margin-top: 30px;
  margin-right: 40px;
  margin-left: 40px;
  background: #92cd41;
  display: inline-block;
  position: relative;
  z-index: 5;
  text-align: center;
  font-size: 30px;
  padding: 20px;
  text-decoration: none;
  color: white;
  box-shadow: inset -4px -4px 0px 0px #4aa52e;
  &:hover {
    background: #76c442;
    box-shadow: inset -6px -6px 0px 0px #4aa52e;
  }
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: content-box;
    top: -6px;
    left: 0;
    border-top: 6px black solid;
    border-bottom: 6px black solid;
  }
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: content-box;
    left: -6px;
    top: 0;
    border-left: 6px black solid;
    border-right: 6px black solid;
  }
`;
const GameButton = styled(BitButton)`
  box-shadow: inset -4px -4px 0px 0px #8c2022;
  background: #e76e55;
  &:hover {
    background: #ce372b;
    box-shadow: inset -6px -6px 0px 0px #8c2022;
  }
`;

const Game = styled.canvas`
  display: block;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  image-rendering: optimizeSpeed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  position: absolute;
  width: 100%;
  height: 100%;
  max-width: 1000px;
`;

const NotFoundPage: React.FC<RouteComponentProps> = ({ location = {} }) => {
  const path = location.pathname;
  const gameRef = useRef();

  const [gameStarted, setGameStarted] = useState(false);
  const [gameover, setGameover] = useState(false);

  // ###################################################################
  // Utility functions & classes
  //
  // ###################################################################
  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  function valueInRange(value, min, max) {
    return value <= max && value >= min;
  }

  function checkRectCollision(A, B) {
    let xOverlap =
      valueInRange(A.x, B.x, B.x + B.w) || valueInRange(B.x, A.x, A.x + A.w);

    let yOverlap =
      valueInRange(A.y, B.y, B.y + B.h) || valueInRange(B.y, A.y, A.y + A.h);
    return xOverlap && yOverlap;
  }

  class Point2D {
    constructor(x, y) {
      this.x = typeof x === "undefined" ? 0 : x;
      this.y = typeof y === "undefined" ? 0 : y;
    }
    set(x, y) {
      this.x = x;
      this.y = y;
    }
  }

  class Rect {
    constructor(x, y, w, h) {
      this.x = typeof x === "undefined" ? 0 : x;
      this.y = typeof y === "undefined" ? 0 : y;
      this.w = typeof w === "undefined" ? 0 : w;
      this.h = typeof h === "undefined" ? 0 : h;
    }
    set(x, y) {
      this.x = x;
      this.y = y;
    }
  }

  // ###################################################################
  // Constants
  //
  // ###################################################################
  let CANVAS_WIDTH = 640;
  let CANVAS_HEIGHT = 640;
  let SPRITE_SHEET_SRC =
    "data:image/png;base64,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";
  let LEFT_KEY = 37;
  let RIGHT_KEY = 39;
  let SHOOT_KEY = 38;
  let SPACE_KEY = 32;
  let TEXT_BLINK_FREQ = 500;
  let PLAYER_CLIP_RECT = {
    x: 0,
    y: 204,
    w: 62,
    h: 32,
  };
  let ALIEN_BOTTOM_ROW = [
    {
      x: 0,
      y: 0,
      w: 51,
      h: 34,
    },
    {
      x: 0,
      y: 102,
      w: 51,
      h: 34,
    },
  ];
  let ALIEN_MIDDLE_ROW = [
    {
      x: 0,
      y: 137,
      w: 50,
      h: 33,
    },
    {
      x: 0,
      y: 170,
      w: 50,
      h: 34,
    },
  ];
  let ALIEN_TOP_ROW = [
    {
      x: 0,
      y: 68,
      w: 50,
      h: 32,
    },
    {
      x: 0,
      y: 34,
      w: 50,
      h: 32,
    },
  ];
  let ALIEN_X_MARGIN = 40;
  let ALIEN_SQUAD_WIDTH = 11 * ALIEN_X_MARGIN;

  let canvas = null;
  let ctx;
  let spriteSheetImg = null;
  let bulletImg = null;
  let keyStates = null;
  let prevKeyStates = null;
  let lastTime = 0;
  let player = null;
  let joystick = null;
  let aliens = [];
  let particleManager = null;
  let updateAlienLogic = false;
  let alienDirection = -1;
  let alienYDown = 0;
  let alienCount = 0;
  let wave = 1;
  let hasGameStarted = false;
  let IS_CHROME = false;

  // ###################################################################
  // Entities
  //
  // ###################################################################
  class BaseSprite {
    constructor(img, x, y) {
      this.img = img;
      this.position = new Point2D(x, y);
      this.scale = new Point2D(1, 1);
      this.bounds = new Rect(x, y, this.img.width, this.img.height);
      this.doLogic = true;
    }
    update(dt) {}

    _updateBounds() {
      this.bounds.set(
        this.position.x,
        this.position.y,
        ~~(0.5 + this.img.width * this.scale.x),
        ~~(0.5 + this.img.height * this.scale.y)
      );
    }

    _drawImage() {
      ctx.drawImage(this.img, this.position.x, this.position.y);
    }

    draw(resized) {
      this._updateBounds();
      this._drawImage();
    }
  }

  class SheetSprite extends BaseSprite {
    constructor(sheetImg, clipRect, x, y) {
      super(sheetImg, x, y);
      this.clipRect = clipRect;
      this.bounds.set(x, y, this.clipRect.w, this.clipRect.h);
    }
    update(dt) {}

    _updateBounds() {
      let w = ~~(0.5 + this.clipRect.w * this.scale.x);
      let h = ~~(0.5 + this.clipRect.h * this.scale.y);
      this.bounds.set(this.position.x - w / 2, this.position.y - h / 2, w, h);
    }

    _drawImage() {
      ctx.save();
      ctx.transform(
        this.scale.x,
        0,
        0,
        this.scale.y,
        this.position.x,
        this.position.y
      );
      ctx.drawImage(
        this.img,
        this.clipRect.x,
        this.clipRect.y,
        this.clipRect.w,
        this.clipRect.h,
        ~~(0.5 + -this.clipRect.w * 0.5),
        ~~(0.5 + -this.clipRect.h * 0.5),
        this.clipRect.w,
        this.clipRect.h
      );
      ctx.restore();
    }

    // draw(resized) {
    // (resized);
    // }
  }

  class Player extends SheetSprite {
    constructor() {
      super(
        spriteSheetImg,
        PLAYER_CLIP_RECT,
        CANVAS_WIDTH / 2,
        CANVAS_HEIGHT - 70
      );
      this.scale.set(0.85, 0.85);
      this.lives = 3;
      this.xVel = 0;
      this.bullets = [];
      this.bulletDelayAccumulator = 0;
      this.score = 0;
    }

    reset() {
      this.lives = 3;
      this.score = 0;
      this.position.set(CANVAS_WIDTH / 2, CANVAS_HEIGHT - 70);
    }

    shoot() {
      let bullet = new Bullet(
        this.position.x,
        this.position.y - this.bounds.h / 2,
        1,
        1000
      );
      this.bullets.push(bullet);
    }

    handleInput() {
      // if (isKeyDown(LEFT_KEY) || joystick.left()) {
      if (isKeyDown(LEFT_KEY)) {
        this.xVel = -175;
        // } else if (joystick.left()) {
        //   this.xVel = -joystick.power;
        // } else if (joystick.right()) {
        //   this.xVel = joystick.power;
      } else if (isKeyDown(RIGHT_KEY)) {
        this.xVel = 175;
      } else this.xVel = 0;

      if (wasKeyPressed(SPACE_KEY) || wasKeyPressed(SHOOT_KEY)) {
        if (this.bulletDelayAccumulator > 0.5) {
          this.shoot();
          this.bulletDelayAccumulator = 0;
        }
      }
    }

    updateBullets(dt) {
      for (let i = this.bullets.length - 1; i >= 0; i--) {
        let bullet = this.bullets[i];
        if (bullet.alive) {
          bullet.update(dt);
        } else {
          this.bullets.splice(i, 1);
          bullet = null;
        }
      }
    }

    update(dt) {
      // update time passed between shots
      this.bulletDelayAccumulator += dt;

      // apply x vel
      this.position.x += this.xVel * dt;

      // cap player position in screen bounds
      this.position.x = clamp(
        this.position.x,
        this.bounds.w / 2,
        CANVAS_WIDTH - this.bounds.w / 2
      );
      this.updateBullets(dt);
    }

    draw(resized) {
      this._updateBounds();
      this._drawImage();

      // draw bullets
      for (let i = 0, len = this.bullets.length; i < len; i++) {
        let bullet = this.bullets[i];
        if (bullet.alive) {
          bullet.draw(resized);
        }
      }
    }
  }

  class Bullet extends BaseSprite {
    constructor(x, y, direction, speed) {
      super(bulletImg, x, y);
      this.direction = direction;
      this.speed = speed;
      this.alive = true;
    }
    update(dt) {
      this.position.y -= this.speed * this.direction * dt;

      if (this.position.y < 0) {
        this.alive = false;
      }
    }
  }

  class Enemy extends SheetSprite {
    constructor(clipRects, x, y) {
      super(spriteSheetImg, clipRects[0], x, y);
      this.clipRects = clipRects;
      this.scale.set(0.5, 0.5);
      this.alive = true;
      this.onFirstState = true;
      this.stepDelay = 1; // try 2 secs to start with...
      this.stepAccumulator = 0;
      this.doShoot - false;
      this.bullet = null;
    }
    toggleFrame() {
      this.onFirstState = !this.onFirstState;
      this.clipRect = this.onFirstState ? this.clipRects[0] : this.clipRects[1];
    }

    shoot() {
      this.bullet = new Bullet(
        this.position.x,
        this.position.y + this.bounds.w / 2,
        -1,
        500
      );
    }

    update(dt) {
      this.stepAccumulator += dt;

      if (this.stepAccumulator >= this.stepDelay) {
        if (this.position.x < this.bounds.w / 2 + 20 && alienDirection < 0) {
          updateAlienLogic = true;
        }
        if (
          alienDirection === 1 &&
          this.position.x > CANVAS_WIDTH - this.bounds.w / 2 - 20
        ) {
          updateAlienLogic = true;
        }
        if (this.position.y > CANVAS_WIDTH - 50) {
          reset();
        }

        let fireTest = Math.floor(Math.random() * (this.stepDelay + 1));
        if (getRandomArbitrary(0, 1000) <= 5 * (this.stepDelay + 1)) {
          this.doShoot = true;
        }
        this.position.x += 10 * alienDirection;
        this.toggleFrame();
        this.stepAccumulator = 0;
      }
      this.position.y += alienYDown;

      if (this.bullet !== null && this.bullet.alive) {
        this.bullet.update(dt);
      } else {
        this.bullet = null;
      }
    }

    draw(resized) {
      this._updateBounds();
      this._drawImage();
      if (this.bullet !== null && this.bullet.alive) {
        this.bullet.draw(resized);
      }
    }
  }

  class ParticleExplosion {
    constructor() {
      this.particlePool = [];
      this.particles = [];
    }
    draw() {
      for (let i = this.particles.length - 1; i >= 0; i--) {
        let particle = this.particles[i];
        particle.moves++;
        particle.x += particle.xunits;
        particle.y += particle.yunits + particle.gravity * particle.moves;
        particle.life--;

        if (particle.life <= 0) {
          if (this.particlePool.length < 100) {
            this.particlePool.push(this.particles.splice(i, 1));
          } else {
            this.particles.splice(i, 1);
          }
        } else {
          ctx.globalAlpha = particle.life / particle.maxLife;
          ctx.fillStyle = particle.color;
          ctx.fillRect(particle.x, particle.y, particle.width, particle.height);
          ctx.globalAlpha = 1;
        }
      }
    }
    createExplosion(x, y, color, number, width, height, spd, grav, lif) {
      for (let i = 0; i < number; i++) {
        let angle = Math.floor(Math.random() * 360);
        let speed = Math.floor((Math.random() * spd) / 2) + spd;
        let life = Math.floor(Math.random() * lif) + lif / 2;
        let radians = (angle * Math.PI) / 180;
        let xunits = Math.cos(radians) * speed;
        let yunits = Math.sin(radians) * speed;

        if (this.particlePool.length > 0) {
          let tempParticle = this.particlePool.pop();
          tempParticle.x = x;
          tempParticle.y = y;
          tempParticle.xunits = xunits;
          tempParticle.yunits = yunits;
          tempParticle.life = life;
          tempParticle.color = color;
          tempParticle.width = width;
          tempParticle.height = height;
          tempParticle.gravity = grav;
          tempParticle.moves = 0;
          tempParticle.alpha = 1;
          tempParticle.maxLife = life;
          this.particles.push(tempParticle);
        } else {
          this.particles.push({
            x: x,
            y: y,
            xunits: xunits,
            yunits: yunits,
            life: life,
            color: color,
            width: width,
            height: height,
            gravity: grav,
            moves: 0,
            alpha: 1,
            maxLife: life,
          });
        }
      }
    }
  }

  function setImageSmoothing(value) {
    ctx["imageSmoothingEnabled"] = value;
    ctx["mozImageSmoothingEnabled"] = value;
    ctx["oImageSmoothingEnabled"] = value;
    ctx["webkitImageSmoothingEnabled"] = value;
    ctx["msImageSmoothingEnabled"] = value;
  }

  // ###################################################################
  // Drawing & Update functions
  //
  // ###################################################################
  function updateAliens(dt) {
    if (updateAlienLogic) {
      updateAlienLogic = false;
      alienDirection = -alienDirection;
      alienYDown = 25;
    }

    for (let i = aliens.length - 1; i >= 0; i--) {
      let alien = aliens[i];
      if (!alien.alive) {
        aliens.splice(i, 1);
        alien = null;
        alienCount--;
        if (alienCount < 1) {
          wave++;
          if (wave % 5) {
            player.lives++;
          }
          setupAlienFormation();
        }
        return;
      }

      alien.stepDelay = (alienCount * 20 - wave * 10) / 1000;
      if (alien.stepDelay <= 0.05) {
        alien.stepDelay = 0.05;
      }
      alien.update(dt);

      if (alien.doShoot) {
        alien.doShoot = false;
        alien.shoot();
      }
    }
    alienYDown = 0;
  }

  function resolveBulletEnemyCollisions() {
    let bullets = player.bullets;

    for (let i = 0; i < bullets.length; i++) {
      let bullet = bullets[i];
      for (let j = 0; j < aliens.length; j++) {
        let alien = aliens[j];
        if (checkRectCollision(bullet.bounds, alien.bounds)) {
          alien.alive = bullet.alive = false;
          particleManager.createExplosion(
            alien.position.x,
            alien.position.y,
            "red",
            70,
            5,
            5,
            3,
            0.15,
            50
          );
          player.score += 25;
        }
      }
    }
  }

  function resolveBulletPlayerCollisions() {
    for (let i = 0, len = aliens.length; i < len; i++) {
      let alien = aliens[i];
      if (
        alien.bullet !== null &&
        checkRectCollision(alien.bullet.bounds, player.bounds)
      ) {
        if (player.lives === 0) {
          setGameover(true);
          // if (isMobile) {
          //   joystick.remove();
          // }
          // init();
          reset();
          setGameStarted(false);
        } else {
          alien.bullet.alive = false;
          particleManager.createExplosion(
            player.position.x,
            player.position.y,
            "green",
            100,
            8,
            8,
            6,
            0.001,
            40
          );
          player.position.set(CANVAS_WIDTH / 2, CANVAS_HEIGHT - 70);
          player.lives--;
          break;
        }
      }
    }
  }

  function resolveCollisions() {
    resolveBulletEnemyCollisions();
    resolveBulletPlayerCollisions();
  }

  function updateGame(dt) {
    player.handleInput();
    prevKeyStates = keyStates.slice();
    player.update(dt);
    updateAliens(dt);
    resolveCollisions();
  }

  function drawIntoCanvas(width, height, callback) {
    let temp = gameRef.current;
    temp.width = width;
    temp.height = height;
    let ctx = temp.getContext("2d");
    callback(ctx);
    return temp;
  }

  function fillText(text, x, y, color, fontSize) {
    if (typeof color !== "undefined") ctx.fillStyle = color;
    if (typeof fontSize !== "undefined")
      ctx.font = fontSize + 'px "Press Start 2P"';
    ctx.fillText(text, x, y);
  }

  function fillCenteredText(text, x, y, color, fontSize) {
    let metrics = ctx.measureText(text);
    fillText(text, x - metrics.width / 2, y, color, fontSize);
  }

  function fillBlinkingText(text, x, y, blinkFreq, color, fontSize) {
    if (~~(0.5 + Date.now() / blinkFreq) % 2) {
      fillCenteredText(text, x, y, color, fontSize);
    }
  }

  function drawBottomHud() {
    ctx.fillStyle = "#4d91da";
    ctx.fillRect(0, CANVAS_HEIGHT - 30, CANVAS_WIDTH, 2);
    ctx.fillRect(0, CANVAS_HEIGHT - 30, 2, 30);
    ctx.fillRect(CANVAS_WIDTH - 2, CANVAS_HEIGHT - 30, 2, 30);
    fillText(player.lives + " ", 10, CANVAS_HEIGHT - 7.5, "white", 20);
    ctx.drawImage(
      spriteSheetImg,
      player.clipRect.x,
      player.clipRect.y,
      player.clipRect.w,
      player.clipRect.h,
      45,
      CANVAS_HEIGHT - 23,
      player.clipRect.w * 0.5,
      player.clipRect.h * 0.5
    );
    fillText("Level: ", CANVAS_WIDTH - 215, CANVAS_HEIGHT - 7.5);
    fillCenteredText("SCORE: " + player.score, CANVAS_WIDTH / 2, 20);
    fillBlinkingText(
      wave < 10 ? "0" + wave : wave,
      CANVAS_WIDTH - 25,
      CANVAS_HEIGHT - 7.5,
      TEXT_BLINK_FREQ
    );
  }

  function drawAliens(resized) {
    for (let i = 0; i < aliens.length; i++) {
      let alien = aliens[i];
      alien.draw(resized);
    }
  }

  function drawGame(resized) {
    player.draw(resized);
    drawAliens(resized);
    particleManager.draw();
    drawBottomHud();
  }

  // function resize() {
  //   let w = window.innerWidth;
  //   let h = window.innerHeight;

  //   // calculate the scale factor to keep a correct aspect ratio
  //   let scaleFactor = Math.min(w / CANVAS_WIDTH, h / CANVAS_HEIGHT);

  //   if (IS_CHROME) {
  //     canvas.width = CANVAS_WIDTH * scaleFactor;
  //     canvas.height = CANVAS_HEIGHT * scaleFactor;
  //     setImageSmoothing(false);
  //     ctx.transform(scaleFactor, 0, 0, scaleFactor, 0, 0);
  //   } else {
  //     // resize the canvas css properties
  //     canvas.style.width = CANVAS_WIDTH * scaleFactor + "px";
  //     canvas.style.height = CANVAS_HEIGHT * scaleFactor + "px";
  //   }
  // }

  function preDrawImages() {
    let temp = drawIntoCanvas(2, 8, function (ctx) {
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    });
    bulletImg = new Image();
    bulletImg.src = temp.toDataURL();
  }

  function initCanvas() {
    // create our canvas and context
    // canvas = gameRef.current;
    // ctx = canvas.getContext("2d");

    // turn off image smoothing
    setImageSmoothing(false);

    // create our main sprite sheet img
    spriteSheetImg = new Image();
    spriteSheetImg.src = SPRITE_SHEET_SRC;
    preDrawImages();
    //
    // add event listeners and initially resize
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("keyup", onKeyUp);
  }

  function initGame() {
    aliens = [];
    player = new Player();
    // joystick = new Joystick();
    particleManager = new ParticleExplosion();
    setupAlienFormation();
    drawBottomHud();
  }

  function setupAlienFormation() {
    alienCount = 0;
    for (let i = 0, len = 5 * 11; i < len; i++) {
      let gridX = i % 11;
      let gridY = Math.floor(i / 11);
      let clipRects;
      switch (gridY) {
        case 0:
        case 1:
          clipRects = ALIEN_BOTTOM_ROW;
          break;
        case 2:
        case 3:
          clipRects = ALIEN_MIDDLE_ROW;
          break;
        case 4:
          clipRects = ALIEN_TOP_ROW;
          break;
      }
      aliens.push(
        new Enemy(
          clipRects,
          CANVAS_WIDTH / 2 -
            ALIEN_SQUAD_WIDTH / 2 +
            ALIEN_X_MARGIN / 2 +
            gridX * ALIEN_X_MARGIN,
          CANVAS_HEIGHT / 3.25 - gridY * 40
        )
      );
      alienCount++;
    }
  }

  function reset() {
    aliens = [];
    setupAlienFormation();

    player.reset();
  }

  function animate() {
    let now = window.performance.now();
    let dt = now - lastTime;
    if (dt > 100) dt = 100;
    if (wasKeyPressed(13) && !gameStarted) {
      // initGame();
      setGameStarted(true);
    }

    if (gameStarted) {
      updateGame(dt / 1000);
    }

    // ctx.fillStyle = 'rgba(255, 255, 255, 0)';
    // ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
    // Store the current transformation matrix
    ctx.save();

    // Use the identity matrix while clearing the canvas
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(
      0,
      0,
      CANVAS_WIDTH + window.innerWidth,
      CANVAS_HEIGHT + window.innerHeight
    );

    // Restore the transform
    ctx.restore();

    if (gameStarted) {
      drawGame(false);
    }
    lastTime = now;
    requestAnimationFrame(animate);
  }

  function isKeyDown(key) {
    return keyStates[key];
  }

  function wasKeyPressed(key) {
    return !prevKeyStates[key] && keyStates[key];
  }

  function onKeyDown(e) {
    e.preventDefault();
    keyStates[e.keyCode] = true;
  }

  function onKeyUp(e) {
    e.preventDefault();
    keyStates[e.keyCode] = false;
  }
  useEffect(() => {
    canvas = gameRef.current;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ctx = canvas.getContext("2d");

    if (gameStarted) {
      IS_CHROME = window.navigator.userAgent.indexOf("Chrome") !== -1;
      // init();
      initCanvas();
      keyStates = [];
      prevKeyStates = [];

      let w = window.innerWidth;
      let h = window.innerHeight;

      // calculate the scale factor to keep a correct aspect ratio
      let scaleFactor = Math.min(w / CANVAS_WIDTH, h / CANVAS_HEIGHT);

      if (IS_CHROME) {
        canvas.width = CANVAS_WIDTH * scaleFactor;
        canvas.height = CANVAS_HEIGHT * scaleFactor;
        setImageSmoothing(false);
        ctx.transform(scaleFactor, 0, 0, scaleFactor, 0, 0);
      } else {
        // resize the canvas css properties
        canvas.style.width = CANVAS_WIDTH * scaleFactor + "px";
        canvas.style.height = CANVAS_HEIGHT * scaleFactor + "px";
      }

      initGame();
      animate();

      window.addEventListener("resize", () => {
        let w = window.innerWidth;
        let h = window.innerHeight;

        // calculate the scale factor to keep a correct aspect ratio
        let scaleFactor = Math.min(w / CANVAS_WIDTH, h / CANVAS_HEIGHT);

        if (IS_CHROME) {
          canvas.width = CANVAS_WIDTH * scaleFactor;
          canvas.height = CANVAS_HEIGHT * scaleFactor;
          setImageSmoothing(false);
          ctx.transform(scaleFactor, 0, 0, scaleFactor, 0, 0);
        } else {
          // resize the canvas css properties
          canvas.style.width = CANVAS_WIDTH * scaleFactor + "px";
          canvas.style.height = CANVAS_HEIGHT * scaleFactor + "px";
        }
      });
    }
  });

  return (
    <Background>
      <SEO />
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Press+Start+2P&display=block"
          rel="stylesheet"
        />
      </Helmet>
      <noscript>
        Your browser does not support JavaScript!
        <h3>This page was not found - 404</h3>
      </noscript>

      <Stars>
        {gameStarted ? null : (
          <Into>
            <Game ref={gameRef} />
            {gameover ? (
              <Heading>Game over</Heading>
            ) : (
              <Heading>Oops! 404</Heading>
            )}
            <h3>You just hit {path} and that route that doesn&#39;t exist.</h3>
            <div style={{ paddingTop: "20px" }}>
              <Link to="/">
                <BitButton>Go Home</BitButton>
              </Link>
              <GameButton onClick={() => setGameStarted(true)}>
                Play game
              </GameButton>
              <p style={{ paddingTop: "60px" }}>To play game use arrow keys</p>
            </div>
          </Into>
        )}
      </Stars>
      {gameStarted ? <Game ref={gameRef} /> : null}
    </Background>
  );
};

export default React.memo(NotFoundPage);
